module.exports = __webpack_public_path__ + "img/icon-licenses.d8d094b1.svg";